export default "__VITE_ASSET__96b1fdea__"